var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPricesqft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 20,
    viewBox: "0 0 34 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3388 16.7141L29.058 17.9949L28.2001 17.137L29.4809 15.8562L27.1368 13.512L25.8559 14.7928L24.998 13.9349L26.2788 12.6541L23.9347 10.3099L22.6538 11.5908L21.7959 10.7328L23.0768 9.452L20.7205 7.09575L19.4397 8.37659L18.5818 7.51867L19.8626 6.23783L17.5184 3.89367L16.2376 5.1745L15.3797 4.31659L16.6605 3.03575L13.833 0.208252V17.1249C13.833 18.4541 14.9205 19.5416 16.2497 19.5416H33.1663L30.3388 16.7141ZM17.458 15.9166V8.95658L24.418 15.9166H17.458Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6054 6.00287C11.2974 6.00287 11.8583 5.44291 11.8583 4.75217C11.8583 4.06142 11.2974 3.50146 10.6054 3.50146C9.91347 3.50146 9.35254 4.06142 9.35254 4.75217C9.35254 5.44291 9.91347 6.00287 10.6054 6.00287Z",
    stroke: "#6B6F7B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.364 1.75801C14.364 1.33929 14.0241 1 13.6047 1C13.5573 1 9.08646 1.00061 9.08646 1.00061C8.68251 1.00061 8.29587 0.979382 8.07172 1.20315L1.16834 8.09438C0.943887 8.31814 0.943887 8.68138 1.16834 8.90515L6.44527 14.173C6.66942 14.3968 7.03328 14.3968 7.25743 14.173L14.1605 7.28149C14.3847 7.05803 14.3634 6.68114 14.3634 6.26878C14.3634 6.26878 14.364 1.80531 14.364 1.75801Z",
    stroke: "#6B6F7B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricesqft);
export default __webpack_public_path__ + "static/media/pricesqft.dcc11a7a6a2b8797f0a66ea2a75fe460.svg";
export { ForwardRef as ReactComponent };